import { defineComponent as _defineComponent } from 'vue'
import VsButton from '@/components/vision/VsButton.vue'
import { JobStopType } from 'ironsight-types'
import { computed, toRef } from 'vue'
import { useJobStopsAndInventoryReceipts } from '@/components/tickets/JobStopsAndInventoryReceipts/useJobStopsAndInventoryReceipts'

interface Props {
  jobId: string
  locationId: number
  stopType: JobStopType
  isLocationOwner: boolean
  editReceipts: (locationId: number) => undefined
}

export default /*#__PURE__*/_defineComponent({
  __name: 'JobReceiptChip',
  props: {
    jobId: null,
    locationId: null,
    stopType: null,
    isLocationOwner: { type: Boolean },
    editReceipts: null
  },
  setup(__props: any) {

const props = __props as {
  jobId: string
  locationId: number
  stopType: JobStopType
  isLocationOwner: boolean
  editReceipts: (locationId: number) => undefined
}



const jobIdRef = toRef(props, 'jobId')
const { isStopLoading, hasExistingDestinationLocationReceipts } =
  useJobStopsAndInventoryReceipts(jobIdRef)

const showReceiptButton = computed(
  () =>
    !isStopLoading.value &&
    props.stopType === JobStopType.DropOff &&
    props.isLocationOwner
)
const receiptButtonIcon = computed(() =>
  hasExistingDestinationLocationReceipts.value
    ? 'mdi-receipt-text-outline'
    : 'mdi-receipt-text-plus-outline'
)

return { __sfc: true,props, jobIdRef, isStopLoading, hasExistingDestinationLocationReceipts, showReceiptButton, receiptButtonIcon, VsButton }
}

})